import React, { useEffect, useMemo } from 'react';
import { Menu } from 'antd';
import _ from "lodash";
import { useNavigate } from 'react-router';
import { listToTree } from "@/utils/utils";
import {useCommonStore} from "@/store/useCommonStore";
import {createSelectors, createBase} from "@/store/base";
import { Icon } from "@/component/exComponents/FormIconSelect/IconSelect";

// 创建当前菜单状态管理
export const useCurrentMenuStore = createSelectors(createBase((set, get) => ({
  currentMenu: null,
  navigate:(menu) => {
    set(state => {
      state.currentMenu = menu;
    });
  },
})));

const SideMenu = () => {
  const getMenu = useCommonStore.use.getMenu();
  const menus = useCommonStore.use.menus();
  const navigate = useNavigate();
  const navigateMenu = useCurrentMenuStore.use.navigate();
  useEffect(()=>{
    getMenu();
  },[]);

  //const menus = useSelector(s => s.common.menus.filter(item => { return item.Deleted == false && item.Show == true }));
  const treeMenu = useMemo(()=>listToTree(
      menus
          .filter(item => item.Deleted == "f" && item.Show == "t")
          .map(item => {
    return {
      key: item.Id,
      pid: item.ParentId,
      path: item.Path,
      label: item.Name,
      title: item.Name,
      sortnum: item.SortNum,
      icon: (item.Icon && typeof item.Icon === 'object' ? <Icon {...item.Icon} /> : null)
    }
  }), { idKey: "key", parentKey: "pid", childrenKey: "children", sortNum: "sortnum" }),[ menus ]);
  return (
    <Menu
      mode="inline"
      theme="dark"
      onClick={({ key, keyPath, domEvent }) => {
        const target = menus.find(item=>item.Id == key);
        if (target.Path != null && target.Path != "") {
          navigate(target.Path);
          navigateMenu(target);
        }
      }}
      //defaultSelectedKeys={[curMenu.MenuKey?curMenu.MenuKey:"0"]}
      //defaultOpenKeys={[OpenKeys.MenuKey]}
      //collapsed = {this.props.inlineCollapsed ? "true" : undefined}
      //collapsed="true"
      items={treeMenu}
    >
    </Menu>
  );
}

export default SideMenu;